module.exports = __webpack_public_path__ + "img/weixin.9e5e3145.png";